import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const MailSlice = createSlice({
 name: "mail",
 initialState: {
  error: false,

  mailData: "",
  isMailLoaded: false,
 },
 reducers: {
  setMail: (state, { payload }) => {
   state.mailData = payload;
   state.isMailLoaded = true;
   console.log("in redux", state.mailData);
  },

  setError: (state) => {
   state.error = true;
  },

  setMailLoad: (state) => {
   state.isMailLoaded = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const { setError, setMail, setMailLoad } = MailSlice.actions;

export default MailSlice.reducer;

export function handleGenerateCertificate(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/certificate/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleCertificateLoading() {
 return (dispatch) => {
  dispatch(setMailLoad());
 };
}
export function handleGenerateTestimonial(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/testimonial/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleTestimonialLoading() {
 return (dispatch) => {
  dispatch(setMailLoad());
 };
}
